const fileLend = () => import('@/pages/fileLend/index')
const createFileLend = () => import('@/pages/fileLend/createdEdit')
const fileLendDetail = () => import('@/pages/fileLend/detail')
export default [{
  path: '/fileLend',
  name: '/fileLend',
  component: fileLend,
  meta: {
    storeKey: 'borrow:menu'
  }
},
{
  path: '/createFileLend',
  name: 'CreateFileLend',
  component: createFileLend,
  meta: {
    cache: true
  }
},
{
  path: '/fileLend/fileLendDetail',
  name: 'FileLendDetail',
  component: fileLendDetail,
  meta: {
  }
}
]



// WEBPACK FOOTER //
// ./src/router/fileLend/index.js